// extracted by mini-css-extract-plugin
export default {"summary":"CalcAccordion_summary__UbUkd","logo":"CalcAccordion_logo__B2KuF","title":"CalcAccordion_title__eWvSE","wrap":"CalcAccordion_wrap__o45oJ"};